// 开票
import { InvoiceAction } from '@/redux/actions/bill/invoice/constant';
import { uuid } from '@/utils';

// 发票类型 发票类型【11增值税专用发票 12增值税电子专用发票 13增值税电子专用发票(数电) 21增值税普通发票 22增值税电子普通发票 23增值税电子普通发票(数电)】
export type IInvoicesType = 11 | 12 | 13 | 21 | 22 | 23;

export interface IInvoicesItem {
  id: any;
  invoiceType: IInvoicesType;
  invoiceNo: string;
  invoiceCode: string;
  amount: number;
}

// 开票抽屉等数据
export interface MainState {
  orderList: any[]; // 开票订单
  categories: any[]; // 类别
  invoices: IInvoicesItem[]; // 开票信息 手输
  remark: string; // 备注
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
}

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const initialState: ReducerState = {
  isInit: false,
  isLoading: false,
  orderList: [], // 开票订单列表
  categories: [], // 类别汇总

  invoices: [
    {
      id: uuid(),
      amount: null,
      invoiceCode: '',
      invoiceNo: '',
      invoiceType: null,
    },
  ],
  remark: '',
};

const reducerMap = {
  [InvoiceAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((state, { payload }) => {
    return { ...state, ...payload };
  }),
  [InvoiceAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [InvoiceAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [InvoiceAction.setOrders]: <ActionHandler<any[]>>((state, { payload }) => {
    return { ...state, orders: payload };
  }),
  [InvoiceAction.setInvoiceItems]: <ActionHandler<any[]>>((state, { payload }) => {
    return { ...state, ...payload };
  }),
  [InvoiceAction.updateRemark]: <ActionHandler<any[]>>((state, { payload }) => {
    return { ...state, ...payload };
  }),
  [InvoiceAction.updateInvoiceAmount]: <ActionHandler<any[]>>((state, { payload }) => {
    return { ...state, ...payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'invoice';
